import React from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '~/techstyle-shared/react-components';

export default function PlayIcon({
  size = '1em',
  color = 'currentColor',
  ...rest
}) {
  const theme = useTheme();
  const fill = theme.colors[color] || color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20.375 10.0781L3.875 0.328125C2.51562 -0.46875 0.5 0.328125 0.5 2.25V21.75C0.5 23.5312 2.375 24.6094 3.875 23.7188L20.375 13.9688C21.8281 13.0781 21.8281 10.9688 20.375 10.0781Z"
        fill={fill}
      />
    </svg>
  );
}

PlayIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
